import "./CreateNewRestaurantOAuthPage.css";

import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RestaurantService, } from "deliziora-client-module/client-web";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";

export default function CreateNewRestaurantOAuthPage() {
  const { user, isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();

  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const restaurantId = localStorage.getItem("@restaurantId");
    const email = params.get('email');

    console.log("Restaurant ID:", restaurantId);
    console.log("Email:", email);
    console.log("User:", user);

    RestaurantService.returnRestaurantById(restaurantId)
      .then((res) => {
        let dataObj = Object.assign({}, res.data);
        dataObj.email = email;
        console.log("Restaurant DATAAA:", dataObj);
        console.log("Restaurant EMAIL:", email);
        RestaurantService.addNewRestaurant(dataObj)
          .then((res) => {
            RestaurantService.returnRestaurantById(restaurantId).then((res2) => {
              localStorage.setItem("userData", JSON.stringify(res2.data));
              window.location.href = `${window.location.origin}`;
            });
          }).catch((err) => {
            console.error("Erro ao vincular restaurante:", err);
            alert("Erro ao vincular restaurante. Por favor, tente novamente.");
          });
      })
      .catch((err) => {
        console.error("Erro ao obter informações do restaurante:", err);
        alert("Erro ao obter informações do restaurante. Por favor, verifique o ID do restaurante.");
      });
  }, []);

  return (
    <>
      Carrengando
    </>
  );
}
